import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { IvyFaceComponent } from '../../ivy-face/ivy-face.component';
import { ChatOption } from 'projects/chat-common/src/lib/models/chat.option';

@Component({
  selector: 'app-multi-input-card',
  standalone: true,
  imports: [
    IvyFaceComponent
  ],
  templateUrl: './multi-input-card.component.html',
  styleUrl: './multi-input-card.component.scss'
})
export class MultiInputCardComponent {
  @Input()
  data: ChatMessage;

  @Input()
  selectedOptions: ChatOption[]

  @Output()
  onMultiSelect: EventEmitter<{option: ChatOption, id: string}> = new EventEmitter()

  @Output()
  onDeselect: EventEmitter<{option: ChatOption, id: string}> = new EventEmitter()

  @Input()
  showOptions: boolean;

  select(option: ChatOption) {
    if (this.selectedOptions.includes(option)) {
      this.onDeselect.emit({option, id: this.data.id});
    } else {
      this.onMultiSelect.emit({option, id: this.data.id});
    }
  }
}
